export enum CredentialsTypeEnum {
  ManagementIntegration = 'management',
  RunnerIntegration = 'runner',
  WebsiteIntegration = 'website',
  InternalIntegration = 'internal'
}
